import { render, staticRenderFns } from "./ConfirmTask.vue?vue&type=template&id=578e108a&"
import script from "./ConfirmTask.vue?vue&type=script&lang=js&"
export * from "./ConfirmTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports